
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexHRrXgcybuF_T_UMq4UOEbLKcMsPfuCeSL3WnCVDD5H0Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/index.vue?macro=true";
import { default as loginsDbgmRL8YVub7bf6RFMmbnPmm1YZvEJxmVhCu6_DgnEMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/login.vue?macro=true";
import { default as createN40rdIys7CYXr_45fHcTpShf0cuGcpEZb1qaM_0Nm_45cJkMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/create.vue?macro=true";
import { default as forgot2pMDz8kVrkJY6ZrL1iJpY59MXhzx0g3PUI1DQPd5JIoMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/forgot.vue?macro=true";
import { default as reportsBtnAHSdR_nzymkEKx_452TcAgR4PmIHEQpit0p63_45AmGwMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/reports.vue?macro=true";
import { default as sign_45upFtyYxCIwSsX5L6cG_tF1JNjRqxPGqCsGZYTyR6IunS0Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/sign-up.vue?macro=true";
import { default as insightsHZtQ5lKiiUQ5tswKlb3tcnbxGkDrae4_b2291yoHu48Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/insights.vue?macro=true";
import { default as new_PBw4saYOwmxkQS9qSuqculi3nzcjWSSGUVkTJdk8cgMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/users/new.vue?macro=true";
import { default as new3rgqBpJfM1W7mIuZoV47Qd_AonaBm1ZfMJUmNzg0zLsMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/makers/new.vue?macro=true";
import { default as newYEnrYW59wsf7FLR1P7DgrR0skbqixiANmK24XfLj1jwMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/orders/new.vue?macro=true";
import { default as _91id_93dk_45gdtEnom2rv7ivJxpGxwZ6AVL96DlWfgcTrw_dV3EMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/users/[id].vue?macro=true";
import { default as newgxOF8f_BiGr7H5al9H6UlxKmw_5vFx2VERsiZweBnSsMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/verify/new.vue?macro=true";
import { default as _91id_93oqDWfUw4Ehg5GTpKhtlDdd_CKz9zSp9Io3qx40y50IMMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/makers/[id].vue?macro=true";
import { default as newjY8Nm_7lI00uNRpPCgYAnor3LFQXcv5FzrFO2AoEFiwMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/rewards/new.vue?macro=true";
import { default as indexihhrJB2QBJJsJfR6xF15QuOy4EOYshraTLaOBcdyMXYMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/users/index.vue?macro=true";
import { default as _91id_93aQe4fRVDEYvksiqRLDA96x5afYtj8g0glkfji06r7_45kMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/verify/[id].vue?macro=true";
import { default as integrationsW1P_45_tvo3ptS3wc7ql1nYPqs3kZBUQCALzQnzKQsiIEMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/integrations.vue?macro=true";
import { default as indexqvRUo2HDlrD_M9MSpE2RAFn6A2ADESFEsgdyhcvAurIMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/makers/index.vue?macro=true";
import { default as indexjvrh9UaAqnQiACk2PSApCmLh5awbE6rxIJ8YUCeitrsMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/orders/index.vue?macro=true";
import { default as newRy2gyDydo64gkj6RstNPjA_45_45y7E03dWIeFZPc_IUhmYMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/packages/new.vue?macro=true";
import { default as newv2uLHbXqNEgdGAsNSAT7yyAJKXTSFHqWni5DxpgCfO4Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/products/new.vue?macro=true";
import { default as indexZR3Zr0wJCF38vQ8FR9JCwe3IMGTyGlMxLyHkyiemThYMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/queues/index.vue?macro=true";
import { default as _91id_936mTEUL_hidybhVJ5h3mEZcGZCt4rlCAWyHrKef7Yt60Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/rewards/[id].vue?macro=true";
import { default as newGPuZOKINbPAbeBf5a2bDkDglgevp0vrsDCCJq0eBaoIMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/settings/new.vue?macro=true";
import { default as new0A0_B8nOpTNhPI90AtLjyPcRBm80zKwwgfhqIzjUWuUMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/discounts/new.vue?macro=true";
import { default as _91id_93CmRrtvq0hy_yPHC96_jxS035Hdh4cuTHBP5YBXk9UbkMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/packages/[id].vue?macro=true";
import { default as _91id_93qiVIcrU6Dotm0pemSWojZwekRyvPptvqkkQ75rJye3oMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/password/[id].vue?macro=true";
import { default as _91id_938SxXim3j2ZNHgNn0qQnfcPBsb_45VkRFiR8mZJBnSqf48Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/products/[id].vue?macro=true";
import { default as indexBV__45okwi0bbRVhkiYnZWFu2tmVNszWajLsqGvLwANtoMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/rewards/index.vue?macro=true";
import { default as _91id_93a5b02OWiocYCTNuECn8vEoTpkZLqltmn5HUi5M9hSQkMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/settings/[id].vue?macro=true";
import { default as _91id_93jaQ4TS_45FmTQ3Rr9_45hvq6dyE9Q4PELzeJWWVfUmq2ajoMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/customers/[id].vue?macro=true";
import { default as _91id_93ONDcTCe4iMTRcRYyTomNtRMLXwWdHl57yVx2WDqK8X4Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/discounts/[id].vue?macro=true";
import { default as downloadTckPg6Z9R5yrL6JRpYtmAcmZ84EGgcbjm0esHtjy2SwMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/files/download.vue?macro=true";
import { default as indexl3B18cuf59kA7imJ9w9Rj6eNg4z6jaz8Fq3xB5we3AcMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/packages/index.vue?macro=true";
import { default as indexIzFbKVdLgG1yf7cbhR_BSSr1H9zTFp_45t_450pG2HeXqi8Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/products/index.vue?macro=true";
import { default as index42BJEZ3iOwFHL9s63Q7UXqO_lWrihy3nWozP2N_45Uj8oMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/settings/index.vue?macro=true";
import { default as newozP_45qE7o_45f3PrEPY7lmrRMHJLq0Jjv8juEvVNbH86TEMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/cost-centre/new.vue?macro=true";
import { default as indexbrtNbyUBg73NNWVCO8XhLyRPSJCPpZJveSB86x3oYNQMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/customers/index.vue?macro=true";
import { default as indexAFEBBOV8gv5xLdE5WzgCTwiTkly1GHehzi1fZ27z2_kMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/discounts/index.vue?macro=true";
import { default as _91id_93AfwRMb9vE_45w7D4mDCcqK0gRBF7f6rP_45kXLB4dk9fV98Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/cost-centre/[id].vue?macro=true";
import { default as indexOkBIogOww06XtKX1yHJQPjMSc0bCj3dw3T_45pO_45nYfXUMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/cost-centre/index.vue?macro=true";
import { default as index5HOD_45VDXBEtRDfLH9an9XuR82N31_45mPd6044tHAnIv8Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/orders/[id]/index.vue?macro=true";
import { default as neweBqjr0dfWTga6BOh2TtnNlk6j_NLj0V2_e_45xUmD84E0Meta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/organisations/new.vue?macro=true";
import { default as _91id_93onbrxpSwU_45p32P_Eqt74USW02y5efm0jWD7eYi_ouSYMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/organisations/[id].vue?macro=true";
import { default as index0uUhw8mbopAZdFEir6UU3fP304zzNt400kAYQx3YgxIMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/organisations/index.vue?macro=true";
import { default as newVD3md8iMIFfft0VIG4HMTp_45DplzU_34quEQdxjsQYocMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/maker-categories/new.vue?macro=true";
import { default as _91id_93SdALJ4m_45eBbmO732NHEKUwwLc97Mala3tJQrOf6wGmAMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/maker-categories/[id].vue?macro=true";
import { default as indexgU7ZQuzryF_45xBaEPW35PVBf0_AVeS3yJ9C9CwFjHZvYMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/maker-categories/index.vue?macro=true";
import { default as newosAW8_45iuQLbVdJUVGGW4p7mSyNYalI6A6FLh7DbzUsgMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/product-categories/new.vue?macro=true";
import { default as _91id_9303acnypGpprHZoS1Olu0Qr_45WE_xopf0ROUi3l_45J5LagMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/product-categories/[id].vue?macro=true";
import { default as index4QtqHmKqammftYo35Xxy2SM6koNSSNATu_RKxBWzrZQMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/product-categories/index.vue?macro=true";
import { default as _91id_930qC89fKOAGjQ0nIpdPGYUrIF2VyOvMwAY8Nc23EJuakMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/settings/subConfigs/[id].vue?macro=true";
import { default as transaction_45historyYX5VgPI1YvkuO8fmytdipli1CfQKLQNQ2bfWU4rsmtcMeta } from "/codebuild/output/src3693196591/src/and-dine-hub/pages/orders/[id]/transaction-history.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/login.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/create.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/forgot.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/reports.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/sign-up.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/insights.vue")
  },
  {
    name: "users-new",
    path: "/users/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/users/new.vue")
  },
  {
    name: "makers-new",
    path: "/makers/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/makers/new.vue")
  },
  {
    name: "orders-new",
    path: "/orders/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/orders/new.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/users/[id].vue")
  },
  {
    name: "verify-new",
    path: "/verify/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/verify/new.vue")
  },
  {
    name: "makers-id",
    path: "/makers/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/makers/[id].vue")
  },
  {
    name: "rewards-new",
    path: "/rewards/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/rewards/new.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/users/index.vue")
  },
  {
    name: "verify-id",
    path: "/verify/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/verify/[id].vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/integrations.vue")
  },
  {
    name: "makers",
    path: "/makers",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/makers/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/orders/index.vue")
  },
  {
    name: "packages-new",
    path: "/packages/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/packages/new.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/products/new.vue")
  },
  {
    name: "queues",
    path: "/queues",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/queues/index.vue")
  },
  {
    name: "rewards-id",
    path: "/rewards/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/rewards/[id].vue")
  },
  {
    name: "settings-new",
    path: "/settings/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/settings/new.vue")
  },
  {
    name: "discounts-new",
    path: "/discounts/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/discounts/new.vue")
  },
  {
    name: "packages-id",
    path: "/packages/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/packages/[id].vue")
  },
  {
    name: "password-id",
    path: "/password/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/password/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/products/[id].vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/rewards/index.vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/settings/[id].vue")
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/customers/[id].vue")
  },
  {
    name: "discounts-id",
    path: "/discounts/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/discounts/[id].vue")
  },
  {
    name: "files-download",
    path: "/files/download",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/files/download.vue")
  },
  {
    name: "packages",
    path: "/packages",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/packages/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/products/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/settings/index.vue")
  },
  {
    name: "cost-centre-new",
    path: "/cost-centre/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/cost-centre/new.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/customers/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/discounts/index.vue")
  },
  {
    name: "cost-centre-id",
    path: "/cost-centre/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/cost-centre/[id].vue")
  },
  {
    name: "cost-centre",
    path: "/cost-centre",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/cost-centre/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/orders/[id]/index.vue")
  },
  {
    name: "organisations-new",
    path: "/organisations/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/organisations/new.vue")
  },
  {
    name: "organisations-id",
    path: "/organisations/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/organisations/[id].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/organisations/index.vue")
  },
  {
    name: "maker-categories-new",
    path: "/maker-categories/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/maker-categories/new.vue")
  },
  {
    name: "maker-categories-id",
    path: "/maker-categories/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/maker-categories/[id].vue")
  },
  {
    name: "maker-categories",
    path: "/maker-categories",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/maker-categories/index.vue")
  },
  {
    name: "product-categories-new",
    path: "/product-categories/new",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/product-categories/new.vue")
  },
  {
    name: "product-categories-id",
    path: "/product-categories/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/product-categories/[id].vue")
  },
  {
    name: "product-categories",
    path: "/product-categories",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/product-categories/index.vue")
  },
  {
    name: "settings-subConfigs-id",
    path: "/settings/subConfigs/:id()",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/settings/subConfigs/[id].vue")
  },
  {
    name: "orders-id-transaction-history",
    path: "/orders/:id()/transaction-history",
    component: () => import("/codebuild/output/src3693196591/src/and-dine-hub/pages/orders/[id]/transaction-history.vue")
  }
]